import { Typography } from "@material-ui/core"

const Events = (props) => {

  return ( <>
    <Typography>
      Absolutely! Your song is yours to use for any personal occasion—weddings, proposals, anniversaries, surprise parties, or even that dramatic slow-motion entrance you’ve always dreamed of. Go ahead and make it the soundtrack to your big moment! Just keep in mind that while you have full personal use, if you ever want to use it commercially (like selling it or putting it on streaming services for profit), you’d need to chat with us about a licensing agreement.
    </Typography>
  </> )
}

export default Events
